import { render, staticRenderFns } from "./ActiveAgeingCentreService.vue?vue&type=template&id=21bfc852&"
import script from "./ActiveAgeingCentreService.vue?vue&type=script&lang=js&"
export * from "./ActiveAgeingCentreService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports